import service from '@/utils/request'

export function permissionList(param) {
	return service.request({
		method: 'post',
		url: '/app/permission/treeTable',
		data: param
	})
}
export function treePermissionList() {
	return service.request({
		method: 'post',
		url: '/app/permission/treeList',
	})
}
export function addPermission(param) {
	return service.request({
		method: 'post',
		url: '/app/permission/add',
		data: param
	})
}

export function editPermission(param) {
	return service.request({
		method: 'post',
		url: '/app/permission/edit',
		data: param
	})
}
export function delPermission(param) {
	return service.request({
		method: 'post',
		url: '/app/permission/del',
		data: param
	})
}

export function exportPermission(param) {
	return service.request({
		method: 'post',
		url: '/app/permission/export',
		data: param
	})
}
